import { useContext } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import cx from 'classnames';
import shippingTypeToPrismicKey from 'src/common/utils/shipping-type-to-prismic-key';
import { date } from 'src/common/utils/date-time-formatter';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { getShippingDates } from '../Shipping/duck';
import { withModel } from '../../data-providers/model';
import { PromoCodeContext } from '../../hooks';

import PromoBanners from './PromoBanners';

const getPromoMessage = (banner, props) => {
  let text = banner.text || '';
  if (text.includes('%{code}')) {
    const className = cx('highlight', { [`color-${banner.promoCodeTextColour}`]: banner.promoCodeTextColour });
    const style = `background-color: ${banner.promoCodeBackground}`;
    text = replaceTextWithValues(text, {
      code: `<span class="${className}" style="${style}">${banner.promoCode}</span>`
    });
  }

  if (text.includes('%{lod_')) {
    let shippingDates = props.model.eagleModel.shippingEstimates;
    // eagleModel.shippingEstimates are the estimated dates, ignoring the card content.
    // props.shippingDates - are the estimated dates based on the cart content.
    if (get(props, 'shippingDates.length', 0) > 0) {
      shippingDates = props.shippingDates;
    }

    const shippingValues = shippingDates.reduce((values, shipping) => {
      const key = shippingTypeToPrismicKey(shipping.type);

      values[`lod_${key}`] = date(shipping.xmas_cutoff, props.model.countryModel, {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
      });

      return values;
    }, {});

    text = replaceTextWithValues(text, shippingValues);
  }

  return text;
};

const remapBanners = (banners, props) => (
  banners.map((banner, idx) => ({
    ...banner,
    idx: idx,
    text: getPromoMessage(banner, props),
    trustpilotWidgetVisible: banner.trustpilotWidgetVisible === 'true',
  }))
);

const enhance = compose(
  connect(state => ({
    shippingDates: getShippingDates(state),
  })),
  withModel,
  mapProps(props => {
    const prismicGeneralBanners = get(props, 'model.prismicGlobalContentModel.general.banners', []);
    const banners = prismicGeneralBanners.map(item => item.banner);
    const { activePromo } = useContext(PromoCodeContext);

    return {
      banners: remapBanners(banners, props),
      activePromo,
      ...props,
    };
  }),
  withState('clientBanners', 'addClientBanners', []),
  lifecycle({
    componentDidUpdate(prevProps) {
      const prismicGeneralBanners = get(this.props, 'model.prismicGlobalContentModel.general.banners', []);
      const promo = this.props.activePromo;
      let banners = prismicGeneralBanners.map(item => item.banner);

      if (promo && banners.length > 0) {
        banners[0] = {
          ...banners[0],
          text: promo.banner.text,
          promoCode: promo.code,
          background: promo.banner.background,
          textColour: promo.banner.isColorInverted ? 'white' : 'almost-black',
        };
      }

      banners = remapBanners(banners, this.props);

      if (!isEqual(banners, prevProps.clientBanners)) {
        this.props.addClientBanners(banners);
      }
    },
  }),
);

export default enhance(PromoBanners);
